/** Matches Decimal(28,9) qty columns — keep float math stable at that scale. */
export const QTY_SCALE = 1e9;
//# sourceMappingURL=quantity-scale.js.map